export default "__VITE_ASSET__$BSkGM1p__"